import { RouteObject } from 'react-router-dom'

import MapPage from '@/pages/Map'
import StationsPage from '@/pages/Stations'
import StationPage from '@/pages/Station'
import stationPageLoader from '@/pages/Station/loader'
import StationChargersPage from '@/pages/StationChargers'

import { AppRoutes } from './types/routes'

export const publicRoutes: RouteObject[] = [
  { index: true, element: <MapPage /> },
  { path: AppRoutes.STATIONS, element: <StationsPage /> },
  { path: AppRoutes.STATION, element: <StationPage />, loader: stationPageLoader },
  { path: AppRoutes.STATION_CHARGERS, element: <StationChargersPage />, loader: stationPageLoader },
]
